<div *ngIf="!showContent" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="showContent">
    <app-lading-status-modal *ngIf="isStatusModalOpen" (closeModal)="closeStatusModal()" [lading_uuid]="lading_uuid"></app-lading-status-modal>
    <button mat-raised-button color="primary" style="margin:10px" (click)="openStatusModal()">Change Status</button>
    <button *ngIf="(dismantleService.canDismantle$ | async) && consolidation_id"
        mat-raised-button color="warn" style="margin:10px" (click)="openDismantleDialog()">
        Dismantle Consolidation
    </button>
    <div style="margin: 10px">
        <div *ngFor="let leg of locations">
            {{leg['location']}} : 
            <span *ngFor="let lading of leg['ladings']">{{lading}} </span>
        </div>
    </div>
    <ag-grid-angular style="height: 300px; margin:10px" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef"
        [rowData]="orders" [autoGroupColumnDef]="autoGroupColumnDef" [rowGroupPanelShow]="rowGroupPanelShow"
        [class]="themeClass" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
</ng-container>
